import StepThree from "@/components/dashboard/buyCrypto/StepThree";

export default function BuyCryptoThree() {
  return <StepThree />;
}
